namespace $.$$ {

	export type $shm_hitalama_notification_type = 'info' | 'success' | 'warning' | 'error'

	export type $shm_hitalama_notification_options = {
		id?: string
		title?: string
		message: string
		details?: string
		copy_text?: string
		type?: $shm_hitalama_notification_type
		timeout?: number
	}

	export type $shm_hitalama_notification_item = {
		id: string
		title: string
		message: string
		details: string
		copy_text: string
		type: $shm_hitalama_notification_type
		timeout: number
	}

	export class $shm_hitalama_notifications extends $.$shm_hitalama_notifications {

		static limit = 5

		@ $mol_mem
		static items( next?: readonly $shm_hitalama_notification_item[] ) {
			return next ?? []
		}

		static show( next: string | $shm_hitalama_notification_options ) {
			const options = typeof next === 'string' ? { message: next } : next
			const type = options.type ?? 'info'
			const timeout = options.timeout ?? 5000
			const item = {
				id: options.id ?? `${ Date.now() }_${ Math.random().toString( 36 ).slice( 2 ) }`,
				title: options.title ?? '',
				message: options.message,
				details: options.details ?? '',
				copy_text: options.copy_text ?? options.details ?? '',
				type,
				timeout,
			}

			this.items([ item, ... this.items().filter( prev => prev.id !== item.id ) ].slice( 0, this.limit ))
			if( timeout > 0 && !options.id ) setTimeout( ()=> this.close( item.id ), timeout )

			return item.id
		}

		static info( message: string, title = '' ) {
			return this.show({ type: 'info', title, message })
		}

		static success( message: string, title = '' ) {
			return this.show({ type: 'success', title, message })
		}

		static warning( message: string, title = '' ) {
			return this.show({ type: 'warning', title, message })
		}

		static error( message: string, title = '' ) {
			return this.show({ type: 'error', title, message })
		}

		static close( id: string ) {
			this.items( this.items().filter( item => item.id !== id ) )
		}

		static clear() {
			this.items( [] )
		}

		rows() {
			return $shm_hitalama_notifications.items().map( item => this.Row( item.id ) )
		}

		item( id: string ) {
			return $shm_hitalama_notifications.items().find( item => item.id === id )!
		}

		type( id: string ) {
			return this.item( id )?.type ?? 'info'
		}

		notification_title( id: string ) {
			return this.item( id )?.title ?? ''
		}

		notification_title_visible( id: string ) {
			return this.notification_title( id ) ? [ this.Title( id ) ] : []
		}

		message( id: string ) {
			return this.item( id )?.message ?? ''
		}

		details( id: string ) {
			return this.item( id )?.details ?? ''
		}

		details_visible( id: string ) {
			return this.details( id ) ? [ this.Details_row( id ) ] : []
		}

		@ $mol_action
		copy( id: string, event?: Event | null ) {
			if( !event ) return null
			const text = this.item( id )?.copy_text || this.details( id )
			if( text ) this.$.$mol_dom_context.navigator.clipboard?.writeText( text ).catch( $mol_fail_log )
			return event
		}

		@ $mol_action
		close( id: string ) {
			$shm_hitalama_notifications.close( id )
		}

	}

}
